import {Utilisateur} from 'sigale-angular';

export class UtilisateurSigalett extends Utilisateur {

	public recupererPrenomNom(): string {
		return this.firstName + ' ' + this.lastName;
	}

	/**
	 * Vérifie si l'utilisateur a le droit passé en paramètre
	 *
	 * @param droit le droit à vérifier
	 * @return true si l'utilisateur a le droit, false sinon
	 */
	public hasDroit(droit: string): boolean {
		return !!this.droits[droit];
	}

	override initialiserDroits(): void {
		this.droits = {
			VOIR_PLANNING: false,
			TELETRAVAIL_ABSENCE_RESERVATION: false,
			GESTION_EQUIPE: false,
			VALIDATION_TT: false,
			GESTION_NAVETTE: false,
			RESERVATION_NAVETTE: false
		};
	}

	deserialize(input: any): UtilisateurSigalett {
		Object.assign(this, input);
		return this;
	}
}
